<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  <app-generic-form (payload)="onSubmit($event)" [form]="form" [controls]="controls$ | async"></app-generic-form>
</mat-dialog-content>
